import { Box } from '@applatform/design-system';

/**
 * The mobile-only header band, giving the v2 login the diagonal cut-in v1 has.
 *
 * Purely a shape. `AuthCard` renders the only lockup on mobile and sits
 * directly beneath this, so anything here would stack on top of it.
 *
 */
function MobileBand() {
  return (
    <Box
      aria-hidden="true"
      css={{
        height: '124px',
        backgroundColor: '#242936',
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 9vw))',
        '@media (min-width: 640px) and (min-height: 600px)': {
          height: '172px',
        },
        '@md': { display: 'none' },
      }}
    />
  );
}

export default MobileBand;
